import{KibLabel}from"./kib-label";export default KibLabel;export*from"./typings";